import { connect } from 'react-redux'

import component from 'components/Home'

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatch
})

const mapStateToProps = (state, ownProps) => ({
  staging: state.staging,
  pricelist: state.pricelist,
  orders: state.orders,
  options: state.options,
  uoms: state.uoms,
  date: ownProps.params.date || 'today',
  isLoggedIn: state.auth && state.auth.isLoggedIn,
  isAdmin: state.auth && state.auth.isAdmin,
  user: state.auth && state.auth.user
})

export default connect(mapStateToProps, mapDispatchToProps)(component)



// WEBPACK FOOTER //
// ./src/routes/Home/containers/HomeContainer.js